// Distinct from a load or print failure, so a caller can tell "the browser blocked the print window" apart from a failed download.
export class PrintWindowBlockedError extends Error {
  public constructor() {
    super('The browser blocked the window that prints the PDF.')
    this.name = 'PrintWindowBlockedError'
  }
}
